function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M72.6038 0L51.9317 0.0247232C49.175 0.0247232 46.536 1.12509 44.5846 3.06619L37.0889 10.5462H62.054L69.779 2.83747L72.6038 0Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.9541 0.667664L73.9293 21.2965C73.9293 24.0474 72.8329 26.6809 70.8815 28.6282L63.3857 36.1082V11.1954L71.1107 3.48659L73.9541 0.667664Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.3861 36.1082L42.7139 36.1329C39.9572 36.1329 37.3182 37.2271 35.3668 39.1744L27.8711 46.6544H52.8363L60.5612 38.9457L63.3861 36.1082Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.959 36.5595L64.9342 57.1883C64.9342 59.9393 63.8377 62.5727 61.8864 64.52L54.3906 72.0001V47.0872L62.1156 39.3784L64.959 36.5595Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.515 10.095L14.8428 10.1197C12.0861 10.1197 9.44712 11.2201 7.49575 13.1612L0 20.6412H24.9652L32.6901 12.9324L35.515 10.095Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.0879 10.54L37.0631 31.1689C37.0631 33.9198 35.9667 36.5533 34.0153 38.5005L26.5195 45.9806V21.0677L34.2445 13.359L37.0879 10.54Z",
  fill: "white"
});

const SvgAppSwitcherLogo = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgAppSwitcherLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/app_switcher_logo.fdef9845.svg";
export { ForwardRef as ReactComponent };